// Fase 9 · siGEUS — módulo /app/contedores + widgets dashboard/impacto — GL/ES
import i18n from "@/i18n";

const GL = {
  contedores: {
    nav: "Contedores",
    title: "Rede de contedores e puntos de recollida",
    subtitle: "Fonte oficial siGEUS · Distromel · integración Valoriza en tempo real",
    kpi_col_points: "Puntos de recollida",
    kpi_containers: "Contedores activos",
    kpi_alarms: "Alarmas abertas",
    kpi_weighins_today: "Pesaxes hoxe",
    kpi_kg_today: "kg recollidos hoxe",
    kpi_ytd_kg: "kg AAA",
    tab_map: "Mapa",
    tab_weighins: "Pesaxes recentes",
    tab_alarms: "Alarmas",
    filter_concello: "Concello",
    filter_all: "Todos",
    filter_waste: "Fracción",
    filter_only_alarms: "Só con alarmas",
    popup_col_point: "Punto",
    popup_district: "Distrito",
    popup_frequency: "Frecuencia (días)",
    popup_view_detail: "Ver detalle",
    drawer_recent_weighins: "Pesaxes últimos 30 días",
    drawer_no_weighins: "Aínda non hai pesaxes rexistrados para este punto no período recente.",
    drawer_open_alarms: "Alarmas activas",
    drawer_no_alarms: "Sen alarmas activas.",
    weighins_empty: "O sistema siGEUS aínda non expón pesaxes RSU no rango consultado.",
    alarms_empty: "Sen alarmas rexistradas nos últimos días.",
    th_date: "Data",
    th_point: "Punto",
    th_waste: "Fracción",
    th_kg: "kg",
    th_vehicle: "Vehículo",
    th_route: "Ruta",
    th_type: "Tipo",
    th_priority: "Prior.",
    th_status: "Estado",
    th_opened: "Aberta",
    status_open: "Aberta",
    status_closed: "Pechada",
    layer_toggle: "Puntos siGEUS",
  },
  contedores_widget: {
    weighins_today_title: "Pesaxes hoxe",
    weighins_none: "Aínda sen pesaxes hoxe",
    weighins_kg: "kg recollidos",
    weighins_link: "Ver contedores",
    alarms_title: "Alarmas siGEUS",
    alarms_open: "abertas",
    alarms_none: "Sen alarmas activas",
    alarms_link: "Ver panel de alarmas",
  },
  contedores_impacto: {
    section_kicker: "RECOLLIDA SELECTIVA",
    section_title: "Recollida por fraccións",
    section_sub: "Datos operativos oficiais · Mancomunidade do Salnés",
    total_col_points: "Puntos de recollida",
    total_containers: "Contedores activos",
    ytd_kg: "Recollidos (30 días)",
    intensity: "Intensidade",
    intensity_pending: "Pendente datos pesaxe reais",
    per_capita: "Por habitante",
    num_recogidas: "Nº recollidas",
    by_waste_type: "Por fracción de residuo",
    by_concello: "Repartición por concello",
    ranking_concello: "Ranking eficiencia por concello",
    provisional_note: "* Intensidade estimada mentres non se dispoñan de datos suficientes.",
  },
  intensity: {
    kpi_title: "Intensidade real do servizo",
    kpi_unit: "kg CO₂e / t",
    benchmark_hint: "Benchmark sector (MITMA): 50–70 kg CO₂e/t",
    benchmark_source: "Fonte: MITMA — Guía técnica de recollida de RSU",
    no_data: "Sen datos suficientes",
    no_data_hint: "Publicaremos a intensidade real cando se reciban os primeiros pesaxes.",
  },
  cobertura: {
    section_kicker: "COBERTURA TERRITORIAL",
    section_title: "Cobertura da rede de contedores",
    section_sub: "Ratio poboación / contedor por concello · referencia MITECO",
    total_pop: "Poboación total",
    total_containers: "Contedores",
    avg_ratio: "Ratio medio",
    band_a: "Óptimo (<25)",
    band_b: "Aceptable (25-40)",
    band_c: "Mellorable (40-60)",
    band_d: "Baixo (>60)",
    th_concello: "Concello",
    th_population: "Poboación",
    th_col_points: "Puntos",
    th_containers: "Contedores",
    th_ratio: "Hab/cont",
    th_band: "Banda",
    csv_download: "Descargar CSV",
    map_hint: "Radio proporcional á poboación · cor pola banda MITECO",
    note_provisional: "Contedores estimados proporcionalmente (o sistema non expón enlace container→col_point).",
  },
};

const ES = {
  contedores: {
    nav: "Contenedores",
    title: "Red de contenedores y puntos de recogida",
    subtitle: "Fuente oficial siGEUS · Distromel · integración Valoriza en tiempo real",
    kpi_col_points: "Puntos de recogida",
    kpi_containers: "Contenedores activos",
    kpi_alarms: "Alarmas abiertas",
    kpi_weighins_today: "Pesajes hoy",
    kpi_kg_today: "kg recogidos hoy",
    kpi_ytd_kg: "kg YTD",
    tab_map: "Mapa",
    tab_weighins: "Pesajes recientes",
    tab_alarms: "Alarmas",
    filter_concello: "Municipio",
    filter_all: "Todos",
    filter_waste: "Fracción",
    filter_only_alarms: "Sólo con alarmas",
    popup_col_point: "Punto",
    popup_district: "Distrito",
    popup_frequency: "Frecuencia (días)",
    popup_view_detail: "Ver detalle",
    drawer_recent_weighins: "Pesajes últimos 30 días",
    drawer_no_weighins: "Aún no hay pesajes registrados para este punto en el periodo reciente.",
    drawer_open_alarms: "Alarmas activas",
    drawer_no_alarms: "Sin alarmas activas.",
    weighins_empty: "El sistema siGEUS aún no expone pesajes RSU en el rango consultado.",
    alarms_empty: "Sin alarmas registradas en los últimos días.",
    th_date: "Fecha",
    th_point: "Punto",
    th_waste: "Fracción",
    th_kg: "kg",
    th_vehicle: "Vehículo",
    th_route: "Ruta",
    th_type: "Tipo",
    th_priority: "Prior.",
    th_status: "Estado",
    th_opened: "Abierta",
    status_open: "Abierta",
    status_closed: "Cerrada",
    layer_toggle: "Puntos siGEUS",
  },
  contedores_widget: {
    weighins_today_title: "Pesajes hoy",
    weighins_none: "Aún sin pesajes hoy",
    weighins_kg: "kg recogidos",
    weighins_link: "Ver contenedores",
    alarms_title: "Alarmas siGEUS",
    alarms_open: "abiertas",
    alarms_none: "Sin alarmas activas",
    alarms_link: "Ver panel de alarmas",
  },
  contedores_impacto: {
    section_kicker: "RECOGIDA SELECTIVA",
    section_title: "Recogida por fracciones",
    section_sub: "Datos operativos oficiales · Mancomunidad do Salnés",
    total_col_points: "Puntos de recogida",
    total_containers: "Contenedores activos",
    ytd_kg: "Recogidos (30 días)",
    intensity: "Intensidad",
    intensity_pending: "Pendiente datos pesaje reales",
    per_capita: "Por habitante",
    num_recogidas: "Nº recogidas",
    by_waste_type: "Por fracción de residuo",
    by_concello: "Reparto por municipio",
    ranking_concello: "Ranking eficiencia por municipio",
    provisional_note: "* Intensidad estimada mientras no se disponga de datos suficientes.",
  },
  intensity: {
    kpi_title: "Intensidad real del servicio",
    kpi_unit: "kg CO₂e / t",
    benchmark_hint: "Benchmark sector (MITMA): 50–70 kg CO₂e/t",
    benchmark_source: "Fuente: MITMA — Guía técnica de recogida de RSU",
    no_data: "Sin datos suficientes",
    no_data_hint: "Publicaremos la intensidad real cuando se reciban los primeros pesajes.",
  },
  cobertura: {
    section_kicker: "COBERTURA TERRITORIAL",
    section_title: "Cobertura de la red de contenedores",
    section_sub: "Ratio población / contenedor por municipio · referencia MITECO",
    total_pop: "Población total",
    total_containers: "Contenedores",
    avg_ratio: "Ratio medio",
    band_a: "Óptimo (<25)",
    band_b: "Aceptable (25-40)",
    band_c: "Mejorable (40-60)",
    band_d: "Bajo (>60)",
    th_concello: "Municipio",
    th_population: "Población",
    th_col_points: "Puntos",
    th_containers: "Contenedores",
    th_ratio: "Hab/cont",
    th_band: "Banda",
    csv_download: "Descargar CSV",
    map_hint: "Radio proporcional a la población · color por la banda MITECO",
    note_provisional: "Contenedores estimados proporcionalmente (el sistema no expone enlace container→col_point).",
  },
};

i18n.addResourceBundle("gl", "common", { fase9: GL }, true, true);
i18n.addResourceBundle("es", "common", { fase9: ES }, true, true);

export default {};
